import Input from "../../../../Core/Fields/Floating/Input";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import Tab1Table1 from "./Tab1Table1";
import Tab1Table2 from "./Tab1Table2";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
import ImagePreview from "../../../../utils/ImagePreview";
const Tab1 = ({
  ItemCode,
  group,
  category,
  company,
  brand,
  ItemName,
  DefaultUnitOfMeasures,
  HSN_SAC,
  StandardSellingRate,
  Length_MM,
  Width_MM,
  Hieght_MM,
  Disabled,
  MaintainStock,
  HasBatchNo,
  autoCreateBatch,
  hasExpiryDate,
  retainSample,
  sampleQuantity,
  batchPrefix,
  HasSerialNo,
  SerialNoSetup,
  SerialNumberSeries,
  HasVariants,
  Description,
  Specification,
  Image,
  Is_Ineligible_for_Input_Tax_Credit,
  Quality_Inspection_Template,
  Inspection_Required_before_Purchase,
  Inspection_Required_before_Delivery,
  Include_Item_In_Manufacturing,
  Supply_Raw_Materials_for_Purchase,
setselected_uom_item_data,
selected_uom_item_data,
setselected_tax_item_data,
selected_tax_item_data
}) => {

  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
            <Input
              id="ItemCode"
              style={{
                height: "30px",
                border: ItemCode.Error ? "1px solid red" : "",
              }}
              readOnly
              label="Item Code"
              value={ItemCode.ItemCode}
              onChange={(e) => ItemCode.setItemCode(e.target.value)}
            />
          </div>
        </div>

        <div className="col-3 ">
          <div  className={group.Error ? `mb-3 errorborder` : `mb-3`}>
            <Input  label="Item Group" readOnly value={group.select_group} style={{ height: '30px' }} />
            
           
          </div>
        </div>

        <div className="col-3 ">
          <div  className={category.Error ? `mb-3 errorborder` : `mb-3`}>

            <Input  label="Category" readOnly value={category.select_category} style={{ height: '30px' }} />
            
         
          </div>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
            <Input  label="Company" readOnly value={company.select_company} style={{ height: '30px' }} />
           
          </div>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
             <Input  label="Brand" readOnly value={brand.select_brand} style={{ height: '30px' }} />
           
            
          </div>
        </div>

        <div className="col-3 ">
          <div className="mb-3">
            <Input
              style={{
                height: "30px",
                border: ItemName.Error ? "1px solid red" : "",
              }}
              readOnly
              id="ItemName"
              label="Item Name"
              value={ItemName.ItemName}
              onChange={(e) => ItemName.setItemName(e.target.value)}
            />
          </div>
        </div>

        <div className="col-3 ">
          <div  className="mb-3">
            <Input  label="Default Unit Of Measures" readOnly value={DefaultUnitOfMeasures.select_DefaultUnitOfMeasure} style={{ height: '30px' }} />
           
           
          </div>
        </div>
        <div className="col-3 ">
          <div  className={HSN_SAC.Error ? `mb-3 errorborder` : `mb-3`}>
            <Input  label="HSN/SAC" readOnly value={HSN_SAC.select_HSN_SAC} style={{ height: '30px' }} />
           
          
          </div>
        </div>
       <div className="col-3">
          <div  className={StandardSellingRate.Error ? `mb-3 errorborder` : `mb-3`}>
            <Input  label="Standard Selling Rate" readOnly value={StandardSellingRate.StandardSellingRate} style={{ height: '30px' }} />
           
          
          </div>
        </div>
        <div className="col-3">
          <div className="mb-3">
            <Input
              id="Length_MM"
              label="Length (mm) (Unicommerce)"
              style={{ height: "30px", }}
              value={Length_MM.Length_MM}
              readOnly
              onChange={(e) => Length_MM.setLength_MM(e.target.value)}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="mb-3">
            <Input
              id="Width_MM"
              label="Width (mm) (Unicommerce)"
              style={{ height: "30px", }}
              value={Width_MM.Width_MM}
              onChange={(e) => Width_MM.setWidth_MM(e.target.value)}
              readOnly
            />
          </div>
        </div>
        <div className="col-3">
          <div className="mb-3">
            <Input
              id="Hieght_MM"
              label="Height (mm) (Unicommerce)"
              style={{ height: "30px", }}
              value={Hieght_MM.Hieght_MM}
              onChange={(e) => Hieght_MM.setHieght_MM(e.target.value)}
              readOnly
            />
          </div>
        </div>
        
        <div className="col-2 ">
          <div className="mb-3">
            <Checkbox
              id="Disabled"
              label="Disabled"
                // checked={Disabled}
              value={Disabled?.Disabled || false}
              onChange={(val) => Disabled?.setDisabled?.(val)}
              disabled={true}
            />
          
          </div>
        </div>
        <div className="col-2 ">
          <div className="mb-3">
            <Checkbox
              id="MaintainStock"
              label="Maintain Stock"
              value={MaintainStock?.MaintainStock || false}
              onChange={(val) => MaintainStock?.setMaintainStock?.(val)}
              disabled={true}
            />
          </div>
        </div>
        <div className="col-2 ">
          <div className="mb-3">
            <Checkbox
              id="HasBatchNo"
              label="Has Batch No"
              value={HasBatchNo?.HasBatchNo || 0}
              onChange={(val) => HasBatchNo?.setHasBatchNo?.(val)}
              disabled={true}
            />
          </div>
        </div>
        <div className="col-2 ">
          <div className="mb-3">
            <Checkbox
              id="HasSerialNo"
              label="Has Serial No"
              // checked={HasSerialNo}
              value={HasSerialNo?.HasSerialNo || 0}
              onChange={(val) => HasSerialNo?.setHasSerialNo?.(val)}
              disabled={true}
            />
          </div>
        </div>
        <div className="col-4 ">
          <div className="mb-3">
            <Checkbox
              id="HasVariants"
              label="Has Variants"
              value={HasVariants?.HasVariants || false}
              onChange={(val) => HasVariants?.setHasVariants?.(val)}
              disabled={true}
            />
            <div
              style={{
                fontSize: "9px",
                color: "#00000099",
                marginLeft: "23px",
              }}
            >
              If this item has variants, then it cannot be selected in sales
              orders etc.
            </div>
          </div>
        </div>
         <div className="col-3">
          <div className="mb-3">
            <Input
            readOnly
            style={{ height: "30px" }}
              id="SerialNoSetup"
              label="Serial No Setup"
              placeholder="Serial No Setup"
              value={SerialNoSetup?.SerialNoSetup || ""}
            />
            </div>
        </div>
        <div className="col-3">
              <div className="mb-3">
                <div style={{ flex: '1' }}>
                  <div className="mb-3 d-flex gap-3">
                      <Input
                        id={"ItemImage"}
                        name={"ItemImage"}
                        value={Image ? Image.slice(7):"No Image Uploaded"}
                        readOnly
                        style={{ height: "30px" }}
                      /> 
                      <ImagePreview
                        image_path={Image}
                            />
                    </div>
                  </div>
                </div>
              </div>

    {/* checked Has Serial No */}
 {HasSerialNo?.HasSerialNo===1 && (
  <>
    
    <div className="col-3">
    <div className="mb-3 custom-tooltip">
      <Input
      readOnly
      style={{ height: "30px" } }
        id="SerialNumberSeries"
        label="Serial Number Series"
        placeholder="Serial Number Series"
        value={SerialNumberSeries?.SerialNumberSeries || ""}
        onChange={(e) =>
          SerialNumberSeries?.setSerialNumberSeries?.(e.target.value)
        }
      />
                  
            <span className="tooltip-text-two">Example: ABCD.##### If series is set and Serial No is not mentioned in transactions, then automatic serial number will be created based on this series. If you always want to explicitly mention Serial Nos for this item. leave this blank.</span>
                  
    </div>
  </div>
  </>
)}
{/* end */}

        {/* checked HAS Batch No */}
        {HasBatchNo?.HasBatchNo===1 && (
  <>
    <div className="col-2">
      <div className="mb-3">
        <Checkbox
        disabled={true}
          id="AutoCreateBatch"
          label="Automatically Create New Batch"
          value={autoCreateBatch?.autoCreateBatch || 0}
          onChange={(val) => autoCreateBatch?.setAutoCreateBatch?.(val)}
        />
      </div>
    </div>

    <div className="col-2">
      <div className="mb-3">
        <Checkbox
        disabled={true}
          id="HasExpiryDate"
          label="Has Expiry Date"
          value={hasExpiryDate?.hasExpiryDate || false}
          onChange={(val) => hasExpiryDate?.setHasExpiryDate?.(val)}
        />
      </div>
    </div>

    <div className="col-2">
      <div className="mb-3">
        <Checkbox
        disabled={true}
          id="RetainSample"
          label="Retain Sample"
          value={retainSample?.retainSample || false}
          onChange={(val) => retainSample?.setRetainSample?.(val)}
        />
      </div>
    </div>

    {autoCreateBatch?.autoCreateBatch ===1 && (
     <>
  <div className="col-3">
    <div className="mb-3 custom-tooltip">
      <Input
      readOnly
      style={{ height: "30px" }}
        id="BatchPrefix"
        label="Batch Number Series"
        placeholder="Batch Number Series"
        value={batchPrefix?.batchPrefix || ""}
        onChange={(e) =>
          batchPrefix?.setBatchPrefix?.(e.target.value)
        }
      />
      <span className="tooltip-text-two">
        Example: ABCD.#####. If series is set and Batch No is not mentioned in transactions, then automatic batch number will be created based on this series. If you always want to explicitly mention Batch No for this item, leave this blank. Note: this setting will take priority over the Naming Series Prefix in Stock Settings.
      </span>
    </div>
  </div>
  
  </>
)}
{retainSample?.retainSample  === true && (
     <>
  <div className="col-3">
    <div className="mb-3">
      <Input
      readOnly
      style={{ height: "30px" }}
        id="sampleQuantity"
        label="Max Sample Quantity"
        placeholder="Max Sample Quantity"
        value={sampleQuantity?.sampleQuantity || ""}
        onChange={(e) =>
          sampleQuantity?.setsampleQuantity?.(e.target.value)
        }
      />
      
    </div>
  </div>
  
  </>
)}
  </>
)}
{/* end */}

      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Description</p>
        </div>

        <div className="col-6">
          <div className="mb-3">
            <Textarea
              style={{
                height: "150px",
                border: Description?.Error ? "1px solid red" : "",
              }}
              readOnly
              label="Description"
              value={Description.Description}
              onChange={(e) => Description.setDescription(e.target.value)}
            />
          </div>
        </div>

        <div className="col-6">
          <div className="mb-3">
            <Textarea
              style={{
                height: "150px",
                border: Specification?.Error ? "1px solid red" : "",
              }}
              readOnly
              label="Specification"
               value={Specification.Specification}
              onChange={(e) => Specification.setSpecification(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Units of Measure </p>
        </div>

        <Tab1Table1 setselected_uom_item_data={setselected_uom_item_data}  selected_uom_item_data={selected_uom_item_data}/>
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Taxes </p>
        </div>

        <div className="col-3 ">
          <div className="mb-3">
            <Checkbox
            disabled={true}
              id="Is_Ineligible_for_Input_Tax_Credit"
              label="Is Ineligible for Input Tax Credit"
              value={
                Is_Ineligible_for_Input_Tax_Credit?.Is_Ineligible_for_Input_Tax_Credit ||
                false
              }
              onChange={(val) =>
                Is_Ineligible_for_Input_Tax_Credit?.setIs_Ineligible_for_Input_Tax_Credit?.(
                  val
                )
              }
            />
          </div>
        </div>
        <Tab1Table2 setselected_tax_item_data={setselected_tax_item_data} selected_tax_item_data={selected_tax_item_data}/>
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Quality </p>
        </div>

        <div className="col-3 ">
          <div className="mb-3">
             <Input  label="Quality Inspection Template" readOnly value={Quality_Inspection_Template.select_Quality_Inspection_Template} style={{ height: '30px' }} />
           
             

            
          </div>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
            <Checkbox
              id="Inspection_Required_before_Purchase"
              label="Inspection Required before Purchase"
              value={
                Inspection_Required_before_Purchase?.Inspection_Required_before_Purchase ||
                false
              }
              onChange={(val) =>
                Inspection_Required_before_Purchase?.setInspection_Required_before_Purchase?.(
                  val
                )
              }
              disabled={true}
            />
          </div>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
            <Checkbox
              id="Inspection_Required_before_Delivery"
              label="Inspection Required before Delivery"
              value={
                Inspection_Required_before_Delivery?.Inspection_Required_before_Delivery ||
                false
              }
              onChange={(val) =>
                Inspection_Required_before_Delivery?.setInspection_Required_before_Delivery?.(
                  val
                )
              }
              disabled={true}
            />
          </div>
        </div>
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Manufacturing </p>
        </div>

        <div className="col-3 ">
          <div className="mb-3">
            <Checkbox
              id="Include_Item_In_Manufacturing"
              label="Include Item In Manufacturing"
              value={
                Include_Item_In_Manufacturing?.Include_Item_In_Manufacturing ||
                false
              }
              onChange={(val) =>
                Include_Item_In_Manufacturing?.setInclude_Item_In_Manufacturing?.(
                  val
                )
              }
              disabled={true}
            />
          </div>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
            <Checkbox
              id="Supply_Raw_Materials_for_Purchase"
              label="Supply Raw Materials for Purchase"
              value={
                Supply_Raw_Materials_for_Purchase?.Supply_Raw_Materials_for_Purchase ||
                false
              }
              onChange={(val) =>
                Supply_Raw_Materials_for_Purchase?.setSupply_Raw_Materials_for_Purchase?.(
                  val
                )
              }
              disabled={true}
            />
            <p
              style={{
                paddingLeft: "25px",
                paddingRight: "14px",
                fontWeight: 400,
                fontSize: "9px",
                lineHeight: "16px",
                letterSpacing: "0",
                color: "#00000099",
                fontFamily: "Roboto, sans-serif",
              }}
            >
              If subcontracted to a vendor
            </p>
          </div>
        </div>
      
      </div>
        <div>
          <ActivityCard  docname={ItemCode.ItemCode}  doctype={'Item'}  />

        </div>
    </>
  );
};

export default Tab1;
